import { useState } from "react";

import { Box, Grid, Typography } from "@mui/material";

import { LoadingButton } from "@aclymatepackages/atoms";

const buildRelationshipCopy = (matchedCompanyName, relationshipCount) => {
  const relationshipNoun =
    relationshipCount === 1 ? "relationship" : "relationships";
  const subject = matchedCompanyName
    ? `an existing profile for "${matchedCompanyName}"`
    : "an existing profile";

  return `We found ${subject} with ${relationshipCount} existing ${relationshipNoun} in our system.`;
};

const MergeConfirmationStep = ({
  matchedCompanyName,
  relationshipCount,
  onDecision
}) => {
  const [loadingDecision, setLoadingDecision] = useState(null);

  const chooseDecision = async (decision) => {
    setLoadingDecision(decision);
    await onDecision(decision);
    setLoadingDecision(null);
  };

  return (
    <Grid item>
      <Box py={4}>
        <Grid container direction="column" spacing={2}>
          <Grid item>
            <Typography variant="h4" color="textPrimary">
              Is this your company?
            </Typography>
            <Typography variant="subtitle1" color="textSecondary">
              {buildRelationshipCopy(matchedCompanyName, relationshipCount)}{" "}
              If this is you, joining it keeps your existing transaction and
              vendor history in one place. If it isn&apos;t, we&apos;ll set you up with
              a brand new account instead.
            </Typography>
          </Grid>
          <Grid item container spacing={2} justifyContent="center">
            <Grid item>
              <LoadingButton
                id="merge-confirm-yes"
                color="secondary"
                label="Yes, this is my company"
                onClick={() => chooseDecision("merge")}
                isLoading={loadingDecision === "merge"}
                disabled={!!loadingDecision}
              />
            </Grid>
            <Grid item>
              <LoadingButton
                id="merge-confirm-no"
                color="primary"
                label="No, create a new company"
                onClick={() => chooseDecision("new")}
                isLoading={loadingDecision === "new"}
                disabled={!!loadingDecision}
              />
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Grid>
  );
};
export default MergeConfirmationStep;
